/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@package/api-client/client-config";
import type { GetOrganizationQueryResponse, GetOrganizationPathParams } from "../../types/organizationController/GetOrganization.ts";
import type { RequestConfig, ResponseErrorConfig } from "@package/api-client/client-config";

function getGetOrganizationUrl(orgId: GetOrganizationPathParams["orgId"]) {
  const res = { method: 'GET', url: `/api/organizations/${orgId}` as const }  
  return res
}

/**
 * @summary Get organization details
 * {@link /api/organizations/:orgId}
 */
export async function getOrganization(orgId: GetOrganizationPathParams["orgId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetOrganizationQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetOrganizationUrl(orgId).url.toString(), ... requestConfig })  
  return res.data
}